import { useEffect, useMemo, useState } from "react";
import { useNavigate } from 'react-router-dom';
import LoadingComponent from './../../widgets/LoadingComponent';
import {
  Chart as ChartJS,
  ArcElement,
  BarElement,
  Tooltip,
  Legend,
  plugins
} from 'chart.js';
import { Bar, Doughnut } from 'react-chartjs-2';
import { getData, postData } from "../../api/ApiRest";
import { Box, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, Typography } from "@mui/material";
import { formatDateddMMMyyyy } from "../../widgets/DateTime";
import { formatNumber } from "../../widgets/FormatNumber";
import { useDispatch, useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import { FaBell, FaTools, FaStar, FaNewspaper, FaTimes, FaCheckCircle } from "react-icons/fa";
import { removeNovedades } from "../../store/authSlice";


ChartJS.register(
  ArcElement, BarElement, Tooltip, Legend
);

function Home() {
  const [loading, setLoading] = useState(false);
  const [companyName, setCompanyname] = useState('');

  const [objectPlan, setObjectPlan] = useState({});
  const [objectCertificate, setObjectCertificate] = useState({});
  const [foliosEmision, setFoliosEmision] = useState([]);

  const info = useSelector((state) => state.auth.novedades);
  const dispatch = useDispatch();

  const [showNovedades, setShowNovedades] = useState(false);
  const [loadingAceptar, setLoadingAceptar] = useState(false);

  const [fechaAyer, setFechaAyer] = useState(null);
  const [totales, setTotales] = useState([]); ///Totales por año

  const emisiones = foliosEmision[0]?.emitidas;
  const anualidad = foliosEmision[0]?.folios_Ano;
  const foliosDisponibles = anualidad - emisiones;

  const data = useMemo(() => ({
    labels: ["Emitidas", "Disponible"],
    datasets: [
      {
        data: [emisiones, foliosDisponibles],
        backgroundColor: ["rgba(144, 203, 216, 1)", "rgba(34, 75, 106, 1)"],
        borderWidth: 1,
      }
    ]
  }), [emisiones, foliosDisponibles])

  const options = useMemo(() => ({
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "bottom" },
      datalabels: {
        color: "#fff",
        font: {
          weight: "bold",
          size: 14,
        },
        formatter: (value, context) => {
          let dataset = context.chart.data.dataset[0].data;
          let total = dataset.reduce((a, b) => a + b, 0);
          let porcentaje = total > 0 ? ((value / total) * 100).toFixed(1) + "%" : "0%";

          return `${value} (${porcentaje})`;
        }
      }
    }
  }), []);

  const labels = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
  ];

  const chartData = useMemo(() => {
    const anios = [...new Set(totales.map(v => v.yyyy))];

    const datasets = anios.map((anio, index) => {
      const dataxAnio = Array(12).fill(0);

      totales.forEach(v => {
        if (v.yyyy === anio)
          dataxAnio[v.mmm - 1] = v.total_facturas_emitidas;
      })

      const colors = [
        "rgba(144, 203, 216, 1)",  // azul claro
        "rgba(34, 75, 106, 1)",  // azul oscuro
      ];

      return {
        label: anio.toString(),
        data: dataxAnio,
        backgroundColor: colors[index % colors.length]
      };
    });

    return {
      labels,
      datasets
    }
  }, [totales]);

  const options_barra = useMemo(() => ({
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "top" },
      title: {
        display: true,
        text: 'Emisión mes/año'
      }
    }
  }), []);

  const navigate = useNavigate();

  useEffect(() => {
    if (info && info.length > 0) {
      setShowNovedades(true);
    }
  }, [info]);

  const getIconoNovedad = (tipo) => {
    if (tipo === "A") return <FaBell size={18} color="#fff" />;
    if (tipo === "M") return <FaTools size={18} color="#fff" />;
    if (tipo === "N") return <FaNewspaper size={18} color="#fff" />;
    return <FaBell size={18} color="#fff" />;
  };

  const getColorNovedad = (tipo) => {
    if (tipo === "A") return "#0d6efd";
    if (tipo === "M") return "#198754";
    if (tipo === "N") return "#f5c227";
    return "#6c757d";
  };

  const getTituloNovedad = (tipo) => {
    if (tipo === "A") return "actualización";
    if (tipo === "M") return "mejora";
    if (tipo === "N") return "noticia";
    return "novedad";
  };

  const conteoActualizaciones = info?.filter(n => n.tipo === "A").length ?? 0;
  const conteoMejoras = info?.filter(n => n.tipo === "M").length ?? 0;
  const conteoMejoraExp = info?.filter(n => n.tipo === "N").length ?? 0;

  const handleAceptarNovedades = async () => {
    setLoadingAceptar(true);
    try {
      await postData('api/Configuracion/Novedad/aceptarNovedades', {}, {}).then(response => {
        if (response.status) {
          navigate('/Cliente/NovedadVisualiza');
          dispatch(removeNovedades());
        }

        setLoadingAceptar(false);
      }, error => {
        setLoadingAceptar(false);
        console.log(error);
      })

    } catch (e) {
      console.log(e);
    } finally {
      setLoadingAceptar(false);
      setShowNovedades(false);
    }
  };

  useEffect(() => {
    if (localStorage.getItem('AdminTae') === 'true') {
      navigate('/Home');
    }

    const hoy = new Date();
    const fechaAyer = new Date(hoy);
    fechaAyer.setDate(hoy.getDate() - 1);

    setFechaAyer(fechaAyer);

    const reporteCliente = async () => {
      setLoading(true);

      await getData('api/Cliente/Dashboard/GetData').then(response => {
        if (response.status === true) {
          setObjectPlan(response.objectoPlans);
          setObjectCertificate(response.objectoCertificate);

          setFoliosEmision(response.foliosEmitidos);
          setTotales(response.datosEmisiones);
          setCompanyname(response.companyName);
        } else {
          alert('algo salio mal al cargar la informacion');
        }
        setLoading(false);
      }, error => {
        setLoading(false);
        alert('Algo salio mal al cargar la informacion');
        console.log(error);
      })
    }

    reporteCliente();
  }, [navigate])

  return (
    <div className="BodyComponent">
      <h2 style={{ marginTop: '-25px' }} className="text-center">BIENVENIDO {companyName} A TAE-COL</h2>
      {<LoadingComponent Loading={loading} />}

      <Grid container spacing={2} padding={1}>
        <Grid item xs={12} md={4}>
          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 3,
              boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
              overflow: "hidden",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                bgcolor: "rgba(34, 75, 106, 1)",
                color: "white",
                py: 1,
                px: 2,
                fontWeight: "bold",
              }}
              style={{ textAlign: 'center' }}
            >
              Validez plan
            </Typography>

            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      bgcolor: "rgba(144, 203, 216, 1)",
                      color: "rgba(34, 75, 106, 1)",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    Fecha desde
                  </TableCell>
                  <TableCell
                    sx={{
                      bgcolor: "rgba(144, 203, 216, 1)",
                      color: "rgba(34, 75, 106, 1)",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    Fecha hasta
                  </TableCell>
                  <TableCell
                    sx={{
                      bgcolor: "rgba(144, 203, 216, 1)",
                      color: "rgba(34, 75, 106, 1)",
                      fontWeight: "bold",
                      textAlign: "center",
                      width: 80
                    }}
                  >
                    Días restantes
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                <TableRow hover>
                  <TableCell align="center">{formatDateddMMMyyyy(objectPlan.fechaDesde)}</TableCell>
                  <TableCell align="center">{formatDateddMMMyyyy(objectPlan.fechaHasta)}</TableCell>
                  <TableCell
                    align="center"
                    sx={{ fontWeight: "bold", color: "rgba(34, 75, 106, 1)" }}
                  >
                    {formatNumber(objectPlan.diasPlan)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid item xs={12} md={4}>
          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 3,
              boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
              overflow: "hidden",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                bgcolor: "rgba(34, 75, 106, 1)",
                color: "white",
                py: 1,
                px: 2,
                fontWeight: "bold",
              }}
              style={{ textAlign: 'center' }}
            >
              Validez certificado
            </Typography>

            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      bgcolor: "rgba(144, 203, 216, 1)",
                      color: "rgba(34, 75, 106, 1)",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    Fecha desde
                  </TableCell>
                  <TableCell
                    sx={{
                      bgcolor: "rgba(144, 203, 216, 1)",
                      color: "rgba(34, 75, 106, 1)",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    Fecha hasta
                  </TableCell>
                  <TableCell
                    sx={{
                      bgcolor: "rgba(144, 203, 216, 1)",
                      color: "rgba(34, 75, 106, 1)",
                      fontWeight: "bold",
                      textAlign: "center",
                      width: 80
                    }}
                  >
                    Días restantes
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                <TableRow hover>
                  <TableCell align="center">{formatDateddMMMyyyy(objectCertificate.fechaDesde)}</TableCell>
                  <TableCell align="center">{formatDateddMMMyyyy(objectCertificate.fechaHasta)}</TableCell>
                  <TableCell
                    align="center"
                    sx={{ fontWeight: "bold", color: "rgba(34, 75, 106, 1)" }}
                  >
                    {formatNumber(objectCertificate.diasCertificado)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid item xs={12} md={4}>
          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 3,
              boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
              overflow: "hidden",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                bgcolor: "rgba(34, 75, 106, 1)",
                color: "white",
                py: 1,
                px: 2,
                fontWeight: "bold",
              }}
              style={{ textAlign: 'center' }}
            >
              Emisión folios hasta {formatDateddMMMyyyy(fechaAyer)}
            </Typography>

            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      bgcolor: "rgba(144, 203, 216, 1)",
                      color: "rgba(34, 75, 106, 1)",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    Emitidos
                  </TableCell>
                  <TableCell
                    sx={{
                      bgcolor: "rgba(144, 203, 216, 1)",
                      color: "rgba(34, 75, 106, 1)",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    Disponibles
                  </TableCell>
                  <TableCell
                    sx={{
                      bgcolor: "rgba(144, 203, 216, 1)",
                      color: "rgba(34, 75, 106, 1)",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    % consumido
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                <TableRow hover>
                  <TableCell align="center">{formatNumber(emisiones)}</TableCell>
                  <TableCell align="center">{formatNumber(foliosDisponibles)}</TableCell>
                  <TableCell
                    align="center"
                    sx={{ fontWeight: "bold", color: "rgba(34, 75, 106, 1)" }}
                  >
                    {foliosEmision.length > 0 ? formatNumber(foliosEmision[0].porcentaje) : null} %
                  </TableCell>
                </TableRow>
                <TableRow hover>
                  <TableCell align="center" colSpan={3}>
                    <div style={{ width: "250px", margin: "auto" }}>
                      <Doughnut data={data} options={options} />
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid item xs={12} md={8} style={{ marginTop: '-170px' }}>
          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 3,
              boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
              overflow: "hidden",
              height: '100%'
            }}
          >
            <Typography
              variant="h6"
              sx={{
                bgcolor: "rgba(34, 75, 106, 1)",
                color: "white",
                py: 1,
                px: 2,
                fontWeight: "bold",
              }}
              style={{ textAlign: 'center' }}
            >
              Emisiones
            </Typography>

            <Table>
              <TableBody>
                <TableRow hover>
                  <TableCell align="center" colSpan={3}>
                    <div style={{ width: "500px", margin: "auto", maxWidth: "600px", height: '300px' }}>
                      <Bar data={chartData} options={options_barra} />
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid item xs={12} md={4}>
          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 3,
              boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
              overflow: "hidden",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                bgcolor: "rgba(34, 75, 106, 1)",
                color: "white",
                py: 1,
                px: 2,
                fontWeight: "bold",
              }}
              style={{ textAlign: 'center' }}
            >
              Tipo plan
            </Typography>

            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      bgcolor: "rgba(144, 203, 216, 1)",
                      color: "rgba(34, 75, 106, 1)",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    Plan
                  </TableCell>
                  <TableCell
                    sx={{
                      bgcolor: "rgba(144, 203, 216, 1)",
                      color: "rgba(34, 75, 106, 1)",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    Cant folios
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                <TableRow hover>
                  <TableCell align="center">{foliosEmision.length > 0 ? foliosEmision[0].plan : ""}</TableCell>
                  <TableCell align="center">{foliosEmision.length > 0 ? formatNumber(foliosEmision[0].folios_Ano) : ""}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>

      <Modal
        show={showNovedades}
        onHide={() => setShowNovedades(false)}
        centered
        size="sm"
        backdrop="static"
      >
        <Modal.Header style={{ border: "none", paddingBottom: 0, position: "relative" }}>
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowNovedades(false)}
            style={{ position: "absolute", right: 16, top: 12 }}
          />
        </Modal.Header>

        <Modal.Body style={{ textAlign: "center", padding: "0 28px 8px" }}>
          <div style={{ position: "relative", display: "inline-block", marginBottom: 16 }}>
            <div style={{
              width: 72,
              height: 72,
              borderRadius: "50%",
              background: "linear-gradient(135deg, #e8f4fd 0%, #cce4f6 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto"
            }}>
              <FaBell size={34} color="#1a73e8" />
            </div>
            <span style={{
              position: "absolute",
              top: -4,
              right: -4,
              background: "#1a73e8",
              color: "#fff",
              borderRadius: "50%",
              width: 26,
              height: 26,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 13,
              fontWeight: 700,
              border: "2px solid #fff"
            }}>
              {info?.length ?? 0}
            </span>
          </div>

          <h5 style={{ fontWeight: 700, fontSize: 17, marginBottom: 8, color: "#1a1a2e" }}>
            ¡Nuevas actualizaciones disponibles!
          </h5>
          <p style={{ color: "#6c757d", fontSize: 13, marginBottom: 20 }}>
            Hemos lanzado {info?.length ?? 0} nuevas actualizaciones que mejoran el rendimiento, la estabilidad y tu experiencia en el sistema.
          </p>

          <div style={{ textAlign: "left" }}>
            {conteoActualizaciones > 0 && (
              <div style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: "10px 14px",
                borderRadius: 8,
                border: "1px solid #e9ecef",
                marginBottom: 8,
                background: "#fafafa"
              }}>
                <div style={{
                  width: 36, height: 36, borderRadius: "50%",
                  background: "#0d6efd",
                  display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0
                }}>
                  <FaBell size={16} color="#fff" />
                </div>
                <div>
                  <div style={{ fontWeight: 600, fontSize: 13 }}>{conteoActualizaciones} actualización</div>
                  <div style={{ color: "#6c757d", fontSize: 12 }}>Mejoras y optimizaciones del sistema.</div>
                </div>
              </div>
            )}

            {conteoMejoras > 0 && (
              <div style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: "10px 14px",
                borderRadius: 8,
                border: "1px solid #e9ecef",
                marginBottom: 8,
                background: "#fafafa"
              }}>
                <div style={{
                  width: 36, height: 36, borderRadius: "50%",
                  background: "#198754",
                  display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0
                }}>
                  <FaTools size={16} color="#fff" />
                </div>
                <div>
                  <div style={{ fontWeight: 600, fontSize: 13 }}>{conteoMejoras} mejora</div>
                  <div style={{ color: "#6c757d", fontSize: 12 }}>Nuevas funcionalidades y mejoras.</div>
                </div>
              </div>
            )}

            {conteoMejoraExp > 0 && (
              <div style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: "10px 14px",
                borderRadius: 8,
                border: "1px solid #e9ecef",
                marginBottom: 8,
                background: "#fafafa"
              }}>
                <div style={{
                  width: 36, height: 36, borderRadius: "50%",
                  background: "#f5c227",
                  display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0
                }}>
                  <FaCheckCircle size={16} color="#fff" />
                </div>
                <div>
                  <div style={{ fontWeight: 600, fontSize: 13 }}>{conteoMejoraExp} mejora de experiencia</div>
                  <div style={{ color: "#6c757d", fontSize: 12 }}>Cambios que hacen más fácil tu día a día.</div>
                </div>
              </div>
            )}

            {info?.filter(n => !["A", "M", "N"].includes(n.tipo)).length > 0 && (
              <div style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: "10px 14px",
                borderRadius: 8,
                border: "1px solid #e9ecef",
                marginBottom: 8,
                background: "#fafafa"
              }}>
                <div style={{
                  width: 36, height: 36, borderRadius: "50%",
                  background: "#6c757d",
                  display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0
                }}>
                  <FaBell size={16} color="#fff" />
                </div>
                <div>
                  <div style={{ fontWeight: 600, fontSize: 13 }}>{info.filter(n => !["A", "M", "N"].includes(n.tipo)).length} novedad</div>
                  <div style={{ color: "#6c757d", fontSize: 12 }}>Otras novedades del sistema.</div>
                </div>
              </div>
            )}
          </div>
        </Modal.Body>

        <Modal.Footer style={{ border: "none", justifyContent: "center", flexDirection: "column", gap: 8, padding: "8px 28px 24px" }}>
          <Button
            variant="primary"
            style={{ borderRadius: 8, fontSize: 13, padding: "10px 28px", background: "#1a73e8", border: "none", width: "100%" }}
            onClick={handleAceptarNovedades}
            disabled={loadingAceptar}
          >
            {loadingAceptar ? "Procesando..." : "Ver novedades"}
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
}

export default Home;
